import { observer } from "mobx-react";
import RmaPageStore, { IRmaCancelAction } from "../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import TranslationScope from "../../../../../translation/translation-scope";
import RmaActionModalDefaultReasonEffect from "../rma-action-modal/rma-action-modal-default-reason-effect";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import { FormField } from "../../../../../components/form-field/form-field";
import { Input } from "../../../../../components/inputs/input/input";
import RmaActionModalEmailSection from "../rma-action-modal/rma-action-modal-email-section";
import RmaActionModalLayout from "../rma-action-modal/rma-action-modal-layout";

interface IProps {
	rma: RmaPageStore;
	rmaAction: IRmaCancelAction;
	onCloseClick: () => void;
}

const RmaActionCancelModal: React.FC<IProps> = observer(({rma, rmaAction, onCloseClick}) => {
	const actionStore = rmaAction.store;
	const {getTranslation} = useDashboardTranslation();
	const scope = "dashboard-returns-rma-card";

	const handleSubmit = () => {
		actionStore.submitAction(() => {
			rmsMixpanelStore.trackEvent("d&_cancel_rma_button_confirmed", { RMAID: rma.rmaId });
			onCloseClick();
		});
	};

	const handleDismiss = () => {
		rmsMixpanelStore.trackEvent("d&_rma_keep_current_status", { RMAID: rma.rmaId });
		onCloseClick();
	};

	return (
		<TranslationScope scope="request-canceled-email">
			<RmaActionModalDefaultReasonEffect kind="cancel" reasonField={actionStore.reasonField}/>
			<RmaActionModalLayout
				rmaAction={rmaAction}
				onDismiss={handleDismiss}
				onSubmit={handleSubmit}
				isDisabled={actionStore.isProcessing}
				isLoading={actionStore.isProcessing}
			>
				<FormField label={getTranslation(actionStore.reasonField.label, scope)}>
					<Input
						value={actionStore.reasonField.value}
						onChange={actionStore.reasonField.onChange}
					/>
				</FormField>
				<RmaActionModalEmailSection
					emailStore={actionStore}
				/>
			</RmaActionModalLayout>
		</TranslationScope>
	);
});

export default RmaActionCancelModal;
